import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'visitabile'
})

export class VisitabilePipe implements PipeTransform {
    /**
     * si va a verificare se il percorso e visitabile o meno
     * @param  {any} value
     * @returns iclass
     */
    transform(value: any): string {
        if (value != null) {
            let visitabile: string = value == "true" ? '<i class="fas fa-door-open" title="Aperto"></i>' :  '<i class="fas fa-door-closed" title="Chiuso"></i>';
            return visitabile;
        }
        return "";
    }   
}